import { NgModule } from '@angular/core';
import { ClickOutsideDirective } from '@Shared/Directives/proprietary/click-outside.directive';
import { DocumentDropZoneDirective } from '@Shared/Directives/proprietary/document-drop-zone.directive';
import { InputIDDirective } from '@Shared/Directives/proprietary/input-id.directive';
import { PasswordMatchValidatorDirective } from '@Shared/Directives/proprietary/password-match-validator.directive';
import { RowIDDirective } from '@Shared/Directives/proprietary/row-id.directive';
import { ValidateOnBlurDirective } from '@Shared/Directives/proprietary/validate-on-blur.directive';
import { FormValidationDirective } from './form-validation.directive';
import { LocationSublocationDirective } from './location-sublocation.directive';
import { MultiTabContextMenuItemRefDirective } from './multi-tab-context-menu-item-ref.directive';
import { MultiTabContextMenuTriggerDirective } from './multi-tab-context-menu-trigger.directive';
import { RouterLinkActiveExtensionDirective } from './router-link-active-extension.directive';
import { RouterLinkExtensionDirective } from './router-link-extension.directive';
import { RowItemIDDirective } from './rowitem-id.directive';
import { ScrollOnItemAddedDirective } from './scroll-on-item-added.directive';
import { UXDesignerComponentDirective } from './ux-designer-component.directive';

@NgModule({
    imports: [],
    declarations: [
        ClickOutsideDirective,
        PasswordMatchValidatorDirective,
        ValidateOnBlurDirective,
        DocumentDropZoneDirective,
        RowIDDirective,
        RowItemIDDirective,
        InputIDDirective,
        FormValidationDirective,
        LocationSublocationDirective,
        RouterLinkActiveExtensionDirective,
        RouterLinkExtensionDirective,
        UXDesignerComponentDirective,
        ScrollOnItemAddedDirective,
        MultiTabContextMenuItemRefDirective,
        MultiTabContextMenuTriggerDirective
    ],
    exports: [
        ClickOutsideDirective,
        PasswordMatchValidatorDirective,
        ValidateOnBlurDirective,
        DocumentDropZoneDirective,
        RowIDDirective,
        RowItemIDDirective,
        InputIDDirective,
        FormValidationDirective,
        LocationSublocationDirective,
        RouterLinkActiveExtensionDirective,
        RouterLinkExtensionDirective,
        UXDesignerComponentDirective,
        ScrollOnItemAddedDirective,
        MultiTabContextMenuItemRefDirective,
        MultiTabContextMenuTriggerDirective
    ]
})
export class DirectiveModule { }
